// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Benefit Items
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

// | ------------------------------------------------------------------------

//Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

var item1 = document.querySelector(
  ".benefit-items .benefit-item:first-child"
);
var item2 = document.querySelector(
  ".benefit-items .benefit-item:nth-child(2)"
);
var item3 = document.querySelector(
  ".benefit-items .benefit-item:nth-child(3)"
);

// | ------------------------------------------------------------------------

function benefitItems(showMarkers, benefitItemSection) {

  const itemsHeight = document.querySelector(
    ".benefit-items"
  ).offsetHeight + 50 + "px";

  let matchMedia = gsap.matchMedia();

    matchMedia.add("(min-width: 992px)", () => { 

        let benefitItemsAnimation = gsap.timeline({
          paused: "true",
          scrollTrigger: {
            trigger: ".benefit-items",      
            //start: "center center",
            start: "center center",
            //start: "+=50%",
            //end: "+=50%",
            end: "+=3000",
            //end: "bottom bottom",
            //pinReparent: true,
            pin: ".timeline-trigger",   
            pinnedContainer: ".timeline-trigger",         
            markers: showMarkers,
            scrub: true,
            //snap: [0, 0.5, 1],
            snap: {
              snapTo: [0, 0.5, 1],
              duration: {min: 0.25, max: 0.75}, // the snap animation should be at least 0.25 seconds, but no more than 0.75 seconds (determined by velocity)
              //duration: {min: 0, max: 0.15},
              delay: 0, //.125, // wait 0.125 seconds from the last scroll event before doing the snapping
              ease: "power1.inOut" // the ease of the snap animation ("power3" by default)
            },              
            id: "benefit-items",
          },
        });

        gsap.set(".benefit-item", { position: "absolute" });

        gsap.set(item1, {zIndex: 1, y: 0, filter: "brightness(1)"});
        gsap.set(item2, {zIndex: 2, y: itemsHeight, filter: "brightness(1)"});
        gsap.set(item3, {zIndex: 3, y: itemsHeight, filter: "brightness(1)"});


        benefitItemsAnimation
 
          // First item leaves
          .to(item1,{y: itemsHeight, rotate: 6, scale: .8, filter: "brightness(.7)", duration: 1.5, ease: "power2.out",}, .5)
          
          // Second item enters
          .to(item2,{y: 0, filter: "brightness(1)", duration: 1.5, ease: "power2.in",}, "<-=1")

          // Second item leaves
          .to(item2,{y: itemsHeight, rotate: 6, scale: .8, filter: "brightness(.7)", duration: 1.5, ease: "power2.out"}, 2.5) 
          
          // Third item enters
          .to(item3,{y: 0, filter: "brightness(1)", duration: 1.5, ease: "power2.in",}, "<-=1")  
        

    })

    matchMedia.add("(min-width: 991px)", () => {
      
    })

}

export { benefitItems };
